import { ABORT_ERROR } from './abortControl';
import { makeError } from './exception';

export function abortify<T>(abortSignal: AbortSignal, f: () => Promise<T>): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    if (abortSignal.aborted) {
      reject(makeError('Aborted', ABORT_ERROR, abortSignal.reason));
      return;
    }

    const onAbort = () => {
      abortSignal.removeEventListener('abort', onAbort);
      reject(makeError('Aborted', ABORT_ERROR, abortSignal.reason));
    };

    abortSignal.addEventListener('abort', onAbort);

    f()
      .then((result) => { if (!abortSignal.aborted) { resolve(result); } })
      .catch((error) => { if (!abortSignal.aborted) { reject(error); } })
      .finally(() => { if (!abortSignal.aborted) { abortSignal.removeEventListener('abort', onAbort); } });
  });
}
